import { render, staticRenderFns } from "./ProgramTabTags.vue?vue&type=template&id=6d6a03e7&"
import script from "./ProgramTabTags.vue?vue&type=script&lang=js&"
export * from "./ProgramTabTags.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports